import { createApp } from 'vue';
import { autoAnimatePlugin } from '@formkit/auto-animate/vue';
import docReady from '../../../assets/js/docReady';
import FiberCheckComponent from '../../shared/fiberCheck/fiberCheck.vue';

docReady(() => {
    document.querySelectorAll('.fiber-check-component > .fiber-check-container')
        .forEach((mountPoint) => {
            if (mountPoint.classList.contains('mounted')) {
                return;
            }
            const app = createApp(FiberCheckComponent, {
                prefillOptions: mountPoint.dataset.prefillOptions,
                promotionBanner: mountPoint.dataset.promotionBanner,
                fiberCheckHeader: mountPoint.dataset.fiberCheckHeader,
                fiberCheckCaption: mountPoint.dataset.fiberCheckCaption,
                productTypePrefill: mountPoint.dataset.productTypePrefill,
                providerPrefillOptions: mountPoint.dataset.providerPrefillOptions,
                uri: mountPoint.dataset.uri,
            });
            app.use(autoAnimatePlugin);
            app.mount(mountPoint);
            mountPoint.classList.add('mounted');
        });
});


